import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'

import { LoadingOverlayComponent } from '@app/shared/_components'

@NgModule({
	imports: [CommonModule],
	declarations: [LoadingOverlayComponent],
	exports: [LoadingOverlayComponent],
	schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class LoadingModule {}
